import { render, staticRenderFns } from "./CardtemplateForm.vue?vue&type=template&id=258abc7c"
import script from "./CardtemplateForm.vue?vue&type=script&lang=js"
export * from "./CardtemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports